import { AdManagementSalesforceSubscriptionProductStatus } from '@zg-rentals/ts-ad-management-client';
import { type ComponentProps } from 'react';
import { type Tag } from '@zillow/constellation-10';

type ToneType = ComponentProps<typeof Tag>['tone'];

export const subscriptionStatusMapping: Map<AdManagementSalesforceSubscriptionProductStatus, string> = new Map([
  [AdManagementSalesforceSubscriptionProductStatus.ACTIVE, 'Active'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING_CANCELLATION, 'Pending Cancellation'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING, 'Pending'],
  [AdManagementSalesforceSubscriptionProductStatus.CANCELLED, 'Cancelled'],
  [AdManagementSalesforceSubscriptionProductStatus.EXPIRED, 'Expired'],
  [AdManagementSalesforceSubscriptionProductStatus.PAUSED, 'Paused'],
  [AdManagementSalesforceSubscriptionProductStatus.SUSPENDED, 'Suspended'],
  [AdManagementSalesforceSubscriptionProductStatus.UNPAUSED, 'Unpaused'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING_UNPAUSE, 'Pending Unpause'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING_PAUSE, 'Pending Pause'],
]);

export const subscriptionStatusToneMapping: Map<AdManagementSalesforceSubscriptionProductStatus, ToneType> = new Map([
  [AdManagementSalesforceSubscriptionProductStatus.ACTIVE, 'success'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING_CANCELLATION, 'critical'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING, 'warning'],
  [AdManagementSalesforceSubscriptionProductStatus.CANCELLED, 'critical'],
  [AdManagementSalesforceSubscriptionProductStatus.EXPIRED, 'critical'],
  [AdManagementSalesforceSubscriptionProductStatus.PAUSED, 'warning'],
  [AdManagementSalesforceSubscriptionProductStatus.SUSPENDED, 'warning'],
  [AdManagementSalesforceSubscriptionProductStatus.UNPAUSED, 'success'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING_UNPAUSE, 'info'],
  [AdManagementSalesforceSubscriptionProductStatus.PENDING_PAUSE, 'info'],
]);

export const getSubscriptionStatusConfig = (status: AdManagementSalesforceSubscriptionProductStatus) => {
  return {
    label: subscriptionStatusMapping.get(status) ?? 'unknown',
    tone: subscriptionStatusToneMapping.get(status) ?? 'info',
  };
};

export const zuoraBillingStatusMapping: Map<string, string> = new Map([
  ['Pending', 'Pending'],
  ['Active', 'Active'],
  ['Cancelled', 'Cancelled'],
]);

export const zuoraBillingStatusToneMapping: Map<string, ToneType> = new Map([
  ['Pending', 'warning'],
  ['Active', 'success'],
  ['Cancelled', 'critical'],
]);

export const getZuoraBillingStatusConfig = (status: string) => {
  return {
    label: zuoraBillingStatusMapping.get(status) ?? 'unknown',
    tone: zuoraBillingStatusToneMapping.get(status) ?? 'info',
  };
};
